// Autogenerated from `packages/@members/copy/models.generated/__model__.ts.hbs`

export const ClassSearch = {
  BackLink: 'backLink',
  BackToClassesLink: 'backToClassesLink',
  ClassesFeaturingTitle: 'classesFeaturingTitle',
  ClassesTitle: 'classesTitle',
  LinkTitle: 'linkTitle',
  MusicArtistsTitle: 'musicArtistsTitle',
  NoResultsTitle: 'noResultsTitle',
  NumClasses: 'numClasses',
  NumRelevantSongs: 'numRelevantSongs',
  PopularSearchesTitle: 'popularSearchesTitle',
  SearchInputLabel: 'searchInputLabel',
  Title: 'title',
  RecentSearchesTitle: 'recentSearchesTitle',
  NumResults: 'numResults',
  MusicArtists: 'musicArtists',
  CoreStrength: 'coreStrength',
  Pilates: 'pilates',
  TaylorSwiftYoga: 'taylorSwiftYoga',
  BroadwayRide: 'broadwayRide',
} as const;
